<div class="page-layout">
  <!-- Sidebar -->
  <app-sidebar></app-sidebar>

  <!-- Main Content -->
  <main class="main-content">
    <!-- Breadcrumb -->
    <nav class="breadcrumb">
      <a (click)="goBack()" class="breadcrumb-item clickable">
        <svg viewBox="0 0 24 24" class="breadcrumb-icon">
          <path fill="currentColor" d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/>
        </svg>
      </a>
      <span class="breadcrumb-separator">›</span>
      <a (click)="goBack()" class="breadcrumb-item clickable">Tournaments</a>
      <span class="breadcrumb-separator">›</span>
      <span class="breadcrumb-item active">{{tournamentBasics?.name || 'Loading...'}}</span>
    </nav>

    <!-- Loading State -->
    <div *ngIf="isLoadingBasics" class="loading-container">
      <div class="loading-spinner"></div>
      <p>Loading tournament details...</p>
    </div>

    <!-- Error State -->
    <div *ngIf="errorMessage && !tournamentBasics" class="error-container">
      <p class="error-message">{{errorMessage}}</p>
      <button class="btn btn-primary" (click)="goBack()">Back to Tournaments</button>
    </div>

    <!-- Tournament Details -->
    <div *ngIf="!isLoadingBasics && tournamentBasics" class="tournament-detail">
      <!-- Header -->
      <header class="detail-header">
        <div class="header-left">
          <button class="btn-back" (click)="goBack()">
            <svg viewBox="0 0 24 24">
              <path fill="currentColor" d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/>
            </svg>
            Back
          </button>
          <div class="tournament-title-section">
            <h1 class="tournament-title">{{tournamentBasics.name}}</h1>
            <span class="status-badge" [class]="getStatusClass()">{{getStatus()}}</span>
          </div>
        </div>
      </header>

      <!-- Success/Error Messages -->
      <div *ngIf="successMessage" class="alert alert-success">{{successMessage}}</div>
      <div *ngIf="errorMessage && tournamentBasics" class="alert alert-error">{{errorMessage}}</div>

      <!-- Tabs -->
      <mat-tab-group [selectedIndex]="tabIndex" (selectedIndexChange)="onTabIndexChange($event)" animationDuration="200ms">
        <mat-tab label="Tournament Details">
          <div class="tab-body details-tab">
          <div class="content-card">
            <div class="card-header-with-actions">
              <h2 class="card-title">Basic Information</h2>
              <div class="card-actions">
                <button *ngIf="!isEditing" class="btn btn-primary btn-sm" (click)="toggleEdit()">
                  <svg viewBox="0 0 24 24" class="btn-icon">
                    <path fill="currentColor" d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/>
                  </svg>
                  Edit
                </button>
                <button *ngIf="isEditing" class="btn btn-secondary btn-sm" (click)="toggleEdit()">
                  Cancel
                </button>
                <button *ngIf="isEditing" class="btn btn-primary btn-sm" (click)="saveTournament()" [disabled]="isSaving">
                  {{isSaving ? 'Saving...' : 'Save'}}
                </button>
              </div>
            </div>

            <div *ngIf="!isEditing" class="info-grid">
              <div class="info-item">
                <label>Tournament Name</label>
                <p>{{tournamentBasics.name}}</p>
              </div>
              <div class="info-item">
                <label>Sport</label>
                <p>{{tournamentBasics.sport}}</p>
              </div>
              <div class="info-item">
                <label>Branch</label>
                <p>{{tournamentBasics.branch}}</p>
              </div>
              <div class="info-item">
                <label>Start Date</label>
                <p>{{formatDate(tournamentBasics.startDate)}}</p>
              </div>
              <div class="info-item">
                <label>End Date</label>
                <p>{{formatDate(tournamentBasics.endDate)}}</p>
              </div>
              <div class="info-item">
                <label>Created</label>
                <p>{{formatDate(tournamentBasics.createdAt)}}</p>
              </div>
              <div class="info-item full-width">
                <label>Description</label>
                <p>{{tournamentBasics.description || 'No description provided'}}</p>
              </div>
            </div>

            <form *ngIf="isEditing" class="edit-form">
              <div class="form-grid">
                <div class="form-group">
                  <label for="name">Tournament Name</label>
                  <input type="text" id="name" [(ngModel)]="editForm.name" name="name" required>
                </div>
                <div class="form-group">
                  <label for="sport">Sport</label>
                  <input type="text" id="sport" [(ngModel)]="editForm.sport" name="sport" required>
                </div>
                <div class="form-group">
                  <label for="branch">Branch</label>
                  <input type="text" id="branch" [(ngModel)]="editForm.branch" name="branch" required>
                </div>
                <div class="form-group">
                  <label for="startDate">Start Date</label>
                  <input type="date" id="startDate" [(ngModel)]="editForm.startDate" name="startDate" required>
                </div>
                <div class="form-group">
                  <label for="endDate">End Date</label>
                  <input type="date" id="endDate" [(ngModel)]="editForm.endDate" name="endDate" required>
                </div>
                <div class="form-group full-width">
                  <label for="description">Description</label>
                  <textarea id="description" [(ngModel)]="editForm.description" name="description" rows="3"></textarea>
                </div>
              </div>
            </form>
          </div>

          <div class="content-card">
            <h2 class="card-title">Registration Settings</h2>

            <div *ngIf="!isEditing" class="info-grid">
              <div class="info-item">
                <label>Max Teams</label>
                <p>{{tournamentBasics.maxTeams}}</p>
              </div>
              <div class="info-item">
                <label>Max Individuals</label>
                <p>{{tournamentBasics.maxIndividuals}}</p>
              </div>
              <div class="info-item">
                <label>Team Registration Fee</label>
                <p class="fee-amount">{{tournamentBasics.teamRegistrationFee}} EGP</p>
              </div>
              <div class="info-item">
                <label>Team Fee (Academy)</label>
                <p class="fee-amount">{{tournamentBasics.teamRegistrationFeeAcademy}} EGP</p>
              </div>
              <div class="info-item">
                <label>Individual Registration Fee</label>
                <p class="fee-amount">{{tournamentBasics.individualRegistrationFee}} EGP</p>
              </div>
              <div class="info-item">
                <label>Individual Fee (Academy)</label>
                <p class="fee-amount">{{tournamentBasics.individualRegistrationFeeAcademy}} EGP</p>
              </div>
              <div class="info-item">
                <label>Mobile Home Screen</label>
                <p>
                  <span class="status-badge" [class.status-active]="tournamentBasics.showOnMobileHome" [class.status-inactive]="!tournamentBasics.showOnMobileHome">
                    {{tournamentBasics.showOnMobileHome ? 'Visible' : 'Hidden'}}
                  </span>
                </p>
              </div>
            </div>

            <form *ngIf="isEditing" class="edit-form">
              <div class="form-grid">
                <div class="form-group">
                  <label for="maxTeams">Max Teams</label>
                  <input type="number" id="maxTeams" [(ngModel)]="editForm.maxTeams" name="maxTeams" min="0" required>
                </div>
                <div class="form-group">
                  <label for="maxIndividuals">Max Individuals</label>
                  <input type="number" id="maxIndividuals" [(ngModel)]="editForm.maxIndividuals" name="maxIndividuals" min="0" required>
                </div>
                <div class="form-group">
                  <label for="teamFee">Team Registration Fee (EGP)</label>
                  <input type="number" id="teamFee" [(ngModel)]="editForm.teamRegistrationFee" name="teamFee" min="0" step="0.01" required>
                </div>
                <div class="form-group">
                  <label for="teamFeeAcademy">Team Registration Fee - Academy (EGP)</label>
                  <input type="number" id="teamFeeAcademy" [(ngModel)]="editForm.teamRegistrationFeeAcademy" name="teamFeeAcademy" min="0" step="0.01" required>
                </div>
                <div class="form-group">
                  <label for="individualFee">Individual Registration Fee (EGP)</label>
                  <input type="number" id="individualFee" [(ngModel)]="editForm.individualRegistrationFee" name="individualFee" min="0" step="0.01" required>
                </div>
                <div class="form-group">
                  <label for="individualFeeAcademy">Individual Registration Fee - Academy (EGP)</label>
                  <input type="number" id="individualFeeAcademy" [(ngModel)]="editForm.individualRegistrationFeeAcademy" name="individualFeeAcademy" min="0" step="0.01" required>
                </div>
              </div>

              <div class="form-group">
                <label class="checkbox-label">
                  <input
                    type="checkbox"
                    [(ngModel)]="editForm.showOnMobileHome"
                    name="showOnMobileHome"
                    class="form-checkbox"
                  />
                  <span>Show on mobile home screen</span>
                </label>
                <p class="form-hint">Enable this to display the tournament in the mobile app home slider</p>
              </div>

              <div class="form-group">
                <label class="checkbox-label">
                  <input
                    type="checkbox"
                    [(ngModel)]="editForm.isTeamRegistrationEnabled"
                    name="isTeamRegistrationEnabled"
                    class="form-checkbox"
                  />
                  <span>Enable team registration</span>
                </label>
                <p class="form-hint">Allow users to register as teams for this tournament</p>
              </div>

              <div class="form-group">
                <label class="checkbox-label">
                  <input
                    type="checkbox"
                    [(ngModel)]="editForm.isIndividualRegistrationEnabled"
                    name="isIndividualRegistrationEnabled"
                    class="form-checkbox"
                  />
                  <span>Enable individual registration</span>
                </label>
                <p class="form-hint">Allow users to register as individuals for this tournament</p>
              </div>

              <div class="form-group">
                <label for="bannerUpload">Tournament Banner</label>
                <div *ngIf="tournamentBasics.bannerImageUrl" class="banner-preview">
                  <img [src]="'https://api.apex.macawshub.com' + tournamentBasics.bannerImageUrl" alt="Tournament Banner" />
                </div>
                <input
                  type="file"
                  id="bannerUpload"
                  (change)="onFileSelected($event)"
                  accept="image/png,image/jpeg,image/jpg"
                  class="form-control"
                  [disabled]="isUploadingBanner"
                />
                <p class="form-hint">PNG or JPG, max 10MB. This will be displayed on the mobile app home slider.</p>
                <span *ngIf="isUploadingBanner" class="uploading-text">Uploading...</span>
              </div>
            </form>
          </div>

          <div class="stats-grid" *ngIf="tournamentBasics && paymentSummary">
            <!-- Team Registrations -->
            <div class="stat-card">
              <div class="stat-icon teams">
                <svg viewBox="0 0 24 24">
                  <path fill="currentColor" d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"/>
                </svg>
              </div>
              <div class="stat-content">
                <h3>{{tournamentBasics.totalTeamRegistrations}}</h3>
                <p>Team Registrations</p>
              </div>
            </div>

            <!-- Individual Registrations -->
            <div class="stat-card">
              <div class="stat-icon individuals">
                <svg viewBox="0 0 24 24">
                  <path fill="currentColor" d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
                </svg>
              </div>
              <div class="stat-content">
                <h3>{{tournamentBasics.totalIndividualRegistrations}}</h3>
                <p>Individual Registrations</p>
              </div>
            </div>

            <!-- Expected Revenue -->
            <div class="stat-card">
              <div class="stat-icon revenue">
                <svg viewBox="0 0 24 24">
                  <path fill="currentColor" d="M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z"/>
                </svg>
              </div>
              <div class="stat-content">
                <h3>{{paymentSummary.totalExpectedRevenue}} EGP</h3>
                <p>Expected Revenue</p>
              </div>
            </div>

            <!-- Total Paid -->
            <div class="stat-card">
              <div class="stat-icon paid">
                <svg viewBox="0 0 24 24">
                  <path fill="currentColor" d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
                </svg>
              </div>
              <div class="stat-content">
                <h3>{{paymentSummary.totalReceivedRevenue}} EGP</h3>
                <p>Total Paid</p>
              </div>
            </div>

            <!-- Outstanding Balance -->
            <div class="stat-card">
              <div class="stat-icon outstanding">
                <svg viewBox="0 0 24 24">
                  <path fill="currentColor" d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/>
                </svg>
              </div>
              <div class="stat-content">
                <h3>{{paymentSummary.totalOutstandingRevenue}} EGP</h3>
                <p>Outstanding Balance</p>
              </div>
            </div>

            <!-- Payment Status Breakdown -->
            <div class="stat-card">
              <div class="stat-icon breakdown">
                <svg viewBox="0 0 24 24">
                  <path fill="currentColor" d="M11 2v20c-5.07-.5-9-4.79-9-10s3.93-9.5 9-10zm2.03 0v8.99H22c-.47-4.74-4.24-8.52-8.97-8.99zm0 11.01V22c4.74-.47 8.5-4.25 8.97-8.99h-8.97z"/>
                </svg>
              </div>
              <div class="stat-content">
                <h3>{{(paymentSummary.teamSummary.fullyPaidCount + paymentSummary.individualSummary.fullyPaidCount)}}</h3>
                <p>Fully Paid</p>
                <div class="stat-breakdown">
                  <span>Unpaid: {{paymentSummary.teamSummary.unpaidCount + paymentSummary.individualSummary.unpaidCount}}</span> •
                  <span>Partial: {{paymentSummary.teamSummary.partiallyPaidCount + paymentSummary.individualSummary.partiallyPaidCount}}</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Loading state for payment summary -->
          <div class="stats-grid" *ngIf="isLoadingPaymentSummary">
            <div class="stat-card" *ngFor="let i of [1,2,3,4,5,6]">
              <div class="skeleton-loader" style="height: 80px;"></div>
            </div>
          </div>
        </div>
        </mat-tab>

        <mat-tab>
          <ng-template mat-tab-label>Team Registrations ({{tournamentBasics.totalTeamRegistrations}})</ng-template>
          <div class="tab-body registrations-tab">
          <div class="tab-header-actions">
            <select class="form-control" style="max-width: 200px;" [(ngModel)]="selectedPaymentStatus" (change)="onPaymentFilterChange()">
              <option [ngValue]="null">All Payment Status</option>
              <option [ngValue]="PaymentStatus.Unpaid">Unpaid</option>
              <option [ngValue]="PaymentStatus.PartiallyPaid">Partially Paid</option>
              <option [ngValue]="PaymentStatus.FullyPaid">Fully Paid</option>
            </select>
            <select class="form-control" style="max-width: 200px;" [(ngModel)]="selectedBranch" (change)="onBranchFilterChange()">
              <option [ngValue]="null">All Branches</option>
              <option *ngFor="let branch of availableBranches" [ngValue]="branch">{{ branch }}</option>
            </select>
            <button class="btn btn-primary" (click)="openTeamModal()">
              <svg viewBox="0 0 24 24" class="btn-icon">
                <path fill="currentColor" d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/>
              </svg>
              Add Team Registration
            </button>
          </div>

          <div *ngIf="(teamRegistrationsData?.registrations?.registrations?.length ?? 0) === 0" class="empty-state">
            <svg viewBox="0 0 24 24" class="empty-icon">
              <path fill="currentColor" d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"/>
            </svg>
            <h3>No team registrations yet</h3>
            <p>Team registrations will appear here once teams sign up.</p>
          </div>

          <div *ngFor="let team of teamRegistrationsData?.registrations?.registrations" class="registration-card team-card">
            <div class="card-header" (click)="toggleTeam(team.id)">
              <div class="team-info">
                <button class="expand-btn" [class.expanded]="isTeamExpanded(team.id)">
                  <svg viewBox="0 0 24 24">
                    <path fill="currentColor" d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"/>
                  </svg>
                </button>
                <h3>{{team.teamName}}</h3>
                <span class="status-badge" [class]="'status-' + team.status.toLowerCase()">{{team.status}}</span>
                <span class="badge" [class]="getPaymentStatusBadgeClass(team.paymentStatus)">
                  {{getPaymentStatusLabel(team.paymentStatus)}}
                </span>
                <span *ngIf="team.isAcademyMember" class="badge badge-purple">Academy</span>
              </div>
              <div class="team-meta">
                <span *ngIf="team.jerseyColor" class="jersey-badge" [style.background-color]="team.jerseyColor">
                  {{team.jerseyColor}}
                </span>
                <span class="player-count">{{team.playerCount}} Players</span>
                <button class="btn btn-sm btn-secondary"
                        (click)="openDetailPanel(team, 'team'); $event.stopPropagation()"
                        style="margin-left: auto;">
                  Details
                </button>
              </div>
            </div>
            <div class="card-body" *ngIf="isTeamExpanded(team.id)">
              <div class="info-row">
                <div class="info-col">
                  <label>Registered By</label>
                  <p>{{team.registeredBy}}</p>
                </div>
                <div class="info-col">
                  <label>Phone</label>
                  <p>{{team.phoneNumber}}</p>
                </div>
                <div class="info-col">
                  <label>Nearest Branch</label>
                  <p>{{team.nearestBranch || 'N/A'}}</p>
                </div>
                <div class="info-col">
                  <label>Registered On</label>
                  <p>{{formatDate(team.createdAt)}}</p>
                </div>
              </div>

              <div class="payment-section">
                <h4>Payment Information</h4>
                <div class="info-row">
                  <div class="info-col">
                    <label>Applied Fee</label>
                    <p>{{team.appliedFee | currency:'EGP':'symbol':'1.2-2'}}</p>
                  </div>
                  <div class="info-col">
                    <label>Total Paid</label>
                    <p>{{team.totalPaid | currency:'EGP':'symbol':'1.2-2'}}</p>
                  </div>
                  <div class="info-col">
                    <label>Remaining Balance</label>
                    <p>{{team.remainingBalance | currency:'EGP':'symbol':'1.2-2'}}</p>
                  </div>
                  <div class="info-col">
                    <label>Payment Status</label>
                    <p><span class="badge" [class]="getPaymentStatusBadgeClass(team.paymentStatus)">{{getPaymentStatusLabel(team.paymentStatus)}}</span></p>
                  </div>
                </div>
                <div *ngIf="team.remainingBalance > 0" style="margin-top: 1rem;">
                  <button class="btn btn-primary btn-sm" (click)="openPaymentModal(team.id, 'team', team.remainingBalance); $event.stopPropagation()">
                    <svg viewBox="0 0 24 24" class="btn-icon">
                      <path fill="currentColor" d="M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z"/>
                    </svg>
                    Record Payment
                  </button>
                </div>
              </div>

              <div class="players-section">
                <h4>Players</h4>
                <div class="players-list">
                  <div *ngFor="let player of getSortedPlayers(team.players)" class="player-item">
                    <div class="player-avatar">
                      {{player.fullName.charAt(0)}}
                    </div>
                    <div class="player-details">
                      <p class="player-name">
                        {{player.fullName}}
                        <span *ngIf="player.isCaptain" class="captain-badge">Captain</span>
                      </p>
                      <p class="player-meta">
                        {{calculateAge(player.dateOfBirth)}} years •
                        {{player.skillLevel || 'N/A'}} •
                        {{player.phoneNumber || 'N/A'}}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Pagination Controls for Teams -->
          <div class="pagination-controls" *ngIf="teamTotalPages > 1">
            <button class="btn btn-sm btn-secondary"
                    [disabled]="teamCurrentPage === 1"
                    (click)="onTeamPageChange(teamCurrentPage - 1)">
              Previous
            </button>

            <span class="page-info">
              Page {{ teamCurrentPage }} of {{ teamTotalPages }}
            </span>

            <button class="btn btn-sm btn-secondary"
                    [disabled]="teamCurrentPage === teamTotalPages"
                    (click)="onTeamPageChange(teamCurrentPage + 1)">
              Next
            </button>
          </div>
        </div>
        </mat-tab>

        <mat-tab [disabled]="!tournamentBasics.isIndividualRegistrationEnabled">
          <ng-template mat-tab-label>Individual Registrations ({{tournamentBasics.totalIndividualRegistrations}})</ng-template>
          <div class="tab-body registrations-tab">
          <div class="tab-header-actions">
            <select class="form-control" style="max-width: 200px;" [(ngModel)]="selectedPaymentStatus" (change)="onPaymentFilterChange()">
              <option [ngValue]="null">All Payment Status</option>
              <option [ngValue]="PaymentStatus.Unpaid">Unpaid</option>
              <option [ngValue]="PaymentStatus.PartiallyPaid">Partially Paid</option>
              <option [ngValue]="PaymentStatus.FullyPaid">Fully Paid</option>
            </select>
            <select class="form-control" style="max-width: 200px;" [(ngModel)]="selectedBranch" (change)="onBranchFilterChange()">
              <option [ngValue]="null">All Branches</option>
              <option *ngFor="let branch of availableBranches" [ngValue]="branch">{{ branch }}</option>
            </select>
            <button class="btn btn-primary" (click)="openIndividualModal()">
              <svg viewBox="0 0 24 24" class="btn-icon">
                <path fill="currentColor" d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/>
              </svg>
              Add Individual Registration
            </button>
          </div>

          <div *ngIf="(individualRegistrationsData?.registrations?.registrations?.length ?? 0) === 0" class="empty-state">
            <svg viewBox="0 0 24 24" class="empty-icon">
              <path fill="currentColor" d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
            </svg>
            <h3>No individual registrations yet</h3>
            <p>Individual registrations will appear here once users sign up.</p>
          </div>

          <div class="table-container">
            <table class="data-table" *ngIf="(individualRegistrationsData?.registrations?.registrations?.length ?? 0) > 0">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Branch</th>
                  <th>Age</th>
                  <th>Skill Level</th>
                  <th>Status</th>
                  <th>Academy</th>
                  <th>Fee</th>
                  <th>Paid</th>
                  <th>Balance</th>
                  <th>Payment Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let registration of individualRegistrationsData?.registrations?.registrations">
                  <td>
                    <div class="player-cell">
                      <div class="player-avatar">{{registration.fullName.charAt(0)}}</div>
                      <div>
                        <div class="player-name-main">{{registration.fullName}}</div>
                        <div class="player-sub">By: {{registration.registeredBy}}</div>
                      </div>
                    </div>
                  </td>
                  <td>{{registration.nearestBranch || 'N/A'}}</td>
                  <td>{{calculateAge(registration.dateOfBirth)}} yrs</td>
                  <td>{{registration.skillLevel || 'N/A'}}</td>
                  <td>
                    <span class="status-badge" [class]="'status-' + registration.status.toLowerCase()">
                      {{registration.status}}
                    </span>
                  </td>
                  <td>
                    <span *ngIf="registration.isAcademyMember" class="badge badge-purple">Yes</span>
                    <span *ngIf="!registration.isAcademyMember" class="badge badge-gray">No</span>
                  </td>
                  <td>{{registration.appliedFee | currency:'EGP':'symbol':'1.2-2'}}</td>
                  <td>{{registration.totalPaid | currency:'EGP':'symbol':'1.2-2'}}</td>
                  <td>{{registration.remainingBalance | currency:'EGP':'symbol':'1.2-2'}}</td>
                  <td>
                    <span class="badge" [class]="getPaymentStatusBadgeClass(registration.paymentStatus)">
                      {{getPaymentStatusLabel(registration.paymentStatus)}}
                    </span>
                  </td>
                  <td>
                    <div class="actions-buttons">
                      <button *ngIf="registration.remainingBalance > 0" class="btn btn-primary btn-sm" (click)="openPaymentModal(registration.id, 'individual', registration.remainingBalance)">
                        <svg viewBox="0 0 24 24" class="btn-icon">
                          <path fill="currentColor" d="M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z"/>
                        </svg>
                        Pay
                      </button>
                      <button class="btn btn-sm btn-secondary" (click)="openDetailPanel(registration, 'individual')">
                        Details
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Pagination Controls for Individuals -->
          <div class="pagination-controls" *ngIf="individualTotalPages > 1">
            <button class="btn btn-sm btn-secondary"
                    [disabled]="individualCurrentPage === 1"
                    (click)="onIndividualPageChange(individualCurrentPage - 1)">
              Previous
            </button>

            <span class="page-info">
              Page {{ individualCurrentPage }} of {{ individualTotalPages }}
            </span>

            <button class="btn btn-sm btn-secondary"
                    [disabled]="individualCurrentPage === individualTotalPages"
                    (click)="onIndividualPageChange(individualCurrentPage + 1)">
              Next
            </button>
          </div>
        </div>
        </mat-tab>

        <mat-tab [disabled]="!tournamentBasics.isIndividualRegistrationEnabled" label="Create Team from Individuals">
          <div class="tab-body create-team-tab">
            <div class="info-card">
              <h3>Create Team from Individual Registrations</h3>
              <p>Build teams by selecting from available individual registrations. You can also add new members during team creation.</p>
              <button class="btn btn-primary" (click)="openCreateTeamModal()">
                + Create Team
              </button>
            </div>
          </div>
        </mat-tab>

        <mat-tab>
          <ng-template mat-tab-label>Matches ({{matches.length}})</ng-template>
          <div class="tab-body matches-tab">
          <div class="tab-section-header">
            <h2 class="section-title">Matches</h2>
            <div class="header-actions">
              <button class="btn btn-secondary btn-sm" (click)="openGroupModal()">
                <svg viewBox="0 0 24 24" class="btn-icon"><path fill="currentColor" d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"/></svg>
                Generate Group
              </button>
              <button class="btn btn-primary btn-sm" (click)="openCreateMatchModal()">
                <svg viewBox="0 0 24 24" class="btn-icon"><path fill="currentColor" d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/></svg>
                Add Match
              </button>
            </div>
          </div>

          <!-- Bracket View -->
          <app-bracket *ngIf="matchViewMode === 'bracket' && !isLoadingMatches && matches.length > 0"
            [matches]="matches"
            [branches]="branches"
            (matchUpdated)="onMatchUpdatedFromBracket($event)">
          </app-bracket>

          <!-- Filters & View Toggle -->
          <div *ngIf="!isLoadingMatches && matches.length > 0" class="matches-filters">
            <ng-container *ngIf="matchViewMode === 'list'">
              <mat-form-field class="filter-field">
                <mat-label>Stage</mat-label>
                <mat-select [(ngModel)]="matchFilterStage" name="matchFilterStage">
                  <mat-option value="">All Stages</mat-option>
                  <mat-option *ngFor="let s of matchStageOptions" [value]="s">{{ s }}</mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field class="filter-field">
                <mat-label>Group</mat-label>
                <mat-select [(ngModel)]="matchFilterGroup" name="matchFilterGroup"
                  [disabled]="matchGroupOptions.length === 0">
                  <mat-option value="">All Groups</mat-option>
                  <mat-option *ngFor="let g of matchGroupOptions" [value]="g">{{ g }}</mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field class="filter-field">
                <mat-label>Team</mat-label>
                <input matInput placeholder="Search team..."
                  [(ngModel)]="matchFilterTeamSearch" name="matchFilterTeamSearch"
                  [matAutocomplete]="teamFilterAuto">
                <mat-autocomplete #teamFilterAuto="matAutocomplete"
                  (optionSelected)="onMatchTeamFilterSelect($event.option.value)">
                  <mat-option *ngFor="let t of filteredMatchTeamOptions" [value]="t">{{ t }}</mat-option>
                </mat-autocomplete>
              </mat-form-field>
              <mat-form-field class="filter-field">
                <mat-label>Date</mat-label>
                <input matInput type="date" [(ngModel)]="matchFilterDate" name="matchFilterDate">
              </mat-form-field>
              <button *ngIf="matchFilterStage || matchFilterGroup || matchFilterTeam || matchFilterDate"
                class="btn-clear-filters"
                (click)="matchFilterStage = ''; matchFilterGroup = ''; matchFilterTeam = ''; matchFilterTeamSearch = ''; matchFilterDate = ''">
                Clear filters
              </button>
            </ng-container>
            <div class="spacer"></div>
            <div *ngIf="hasKnockoutMatches" class="view-mode-toggle">
              <button class="toggle-btn" [class.active]="matchViewMode === 'list'" (click)="matchViewMode = 'list'">
                <svg viewBox="0 0 24 24" class="btn-icon"><path fill="currentColor" d="M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z"/></svg>
                List
              </button>
              <button class="toggle-btn" [class.active]="matchViewMode === 'bracket'" (click)="matchViewMode = 'bracket'">
                <svg viewBox="0 0 24 24" class="btn-icon"><path fill="currentColor" d="M22 11V3h-7v3H9V3H2v8h7V8h2v10h4v3h7v-8h-7v3h-2V8h2v3h7zM7 9H4V5h3v4zm10 6h3v4h-3v-4zm0-10h3v4h-3V5z"/></svg>
                Bracket
              </button>
            </div>
          </div>

          <!-- Loading -->
          <div *ngIf="isLoadingMatches" class="loading-container">
            <div class="loading-spinner"></div>
            <p>Loading matches...</p>
          </div>

          <!-- Empty State -->
          <div *ngIf="!isLoadingMatches && matches.length === 0" class="empty-state">
            <svg viewBox="0 0 24 24" class="empty-icon"><path fill="currentColor" d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"/></svg>
            <p>No matches scheduled yet.</p>
            <button class="btn btn-primary btn-sm" (click)="openCreateMatchModal()">Add First Match</button>
          </div>

          <!-- Matches grouped by stage -->
          <div *ngIf="matchViewMode === 'list' && !isLoadingMatches && matches.length > 0" class="matches-list">
            <div *ngFor="let group of getMatchesByStage()" class="stage-group">
              <div class="stage-header">
                <span class="stage-label">{{ group.stage }}</span>
                <span class="stage-count">{{ group.matches.length }} match{{ group.matches.length !== 1 ? 'es' : '' }}</span>
              </div>

              <div class="matches-table-wrapper">
                <table class="matches-table">
                  <thead>
                    <tr>
                      <th>Date & Time</th>
                      <th>Branch</th>
                      <th>Group</th>
                      <th class="match-teams-col">Match</th>
                      <th>Status</th>
                      <th class="actions-col">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let match of group.matches" class="match-row" [class.match-row-draft]="match.status === 'draft'"
                      (click)="openEditMatchModal(match)" title="Click to edit match">
                      <td class="match-date">{{ formatMatchDate(match.scheduledAt) }}</td>
                      <td>
                        <span *ngIf="match.branchName" class="branch-tag">{{ match.branchName }}</span>
                        <span *ngIf="!match.branchName" class="tbd-tag">TBD</span>
                      </td>
                      <td>
                        <span *ngIf="match.groupName" class="group-tag">{{ match.groupName }}</span>
                        <span *ngIf="!match.groupName" class="tbd-tag">—</span>
                      </td>
                      <td class="match-teams-col">
                        <div class="match-teams">
                          <span class="team-name home">{{ match.homeTeamName }}</span>
                          <div class="score-badge" [class]="'score-' + match.status">
                            <ng-container *ngIf="match.status === 'draft'">DRAFT</ng-container>
                            <ng-container *ngIf="match.status === 'upcoming'">VS</ng-container>
                            <ng-container *ngIf="match.status === 'live'">
                              {{ match.homeScore ?? '-' }} – {{ match.awayScore ?? '-' }}
                            </ng-container>
                            <ng-container *ngIf="match.status === 'completed'">
                              {{ match.homeScore ?? '-' }} – {{ match.awayScore ?? '-' }}
                            </ng-container>
                          </div>
                          <span class="team-name away">{{ match.awayTeamName }}</span>
                        </div>
                      </td>
                      <td>
                        <span class="status-badge" [class]="getMatchStatusClass(match.status)">
                          {{ match.status | titlecase }}
                        </span>
                      </td>
                      <td class="actions-col" (click)="$event.stopPropagation()">
                        <button class="btn-icon-action delete" (click)="deleteMatch(match)" title="Delete">
                          <svg viewBox="0 0 24 24"><path fill="currentColor" d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"/></svg>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          </div>
        </mat-tab>
      </mat-tab-group>

    <!-- Match Modal -->
    <div *ngIf="showMatchModal" class="modal-overlay" (click)="closeMatchModal()">
      <div class="modal-content" (click)="$event.stopPropagation()">
        <div class="modal-header">
          <h2>{{ isEditingMatch ? 'Edit Match' : 'Add Match' }}</h2>
          <button class="close-btn" (click)="closeMatchModal()">
            <svg viewBox="0 0 24 24"><path fill="currentColor" d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>
          </button>
        </div>

        <div class="modal-body">
          <div *ngIf="matchErrorMessage" class="alert alert-error">{{ matchErrorMessage }}</div>

          <!-- Create form -->
          <form *ngIf="!isEditingMatch" class="registration-form">
            <div class="form-section">
              <h3>Match Details</h3>
              <div *ngIf="isLoadingRegisteredTeams" class="loading-inline">
                <div class="loading-spinner loading-spinner-sm"></div>
                <span>Loading registered teams...</span>
              </div>
              <div *ngIf="!isLoadingRegisteredTeams && registeredTeams.length === 0" class="alert alert-error" style="margin-bottom: 1rem;">
                No registered teams found for this tournament. Register teams first before adding matches.
              </div>
              <div class="form-grid-2">
                <div class="form-group">
                  <label>Home Team <span class="required">*</span></label>
                  <mat-form-field class="full-width">
                    <input matInput placeholder="Search home team..."
                      [(ngModel)]="homeTeamFilter" name="homeTeamFilter"
                      [matAutocomplete]="homeAuto"
                      [disabled]="isLoadingRegisteredTeams">
                    <mat-autocomplete #homeAuto="matAutocomplete"
                      (optionSelected)="onTeamSelect('home', $event.option.value)"
                      [displayWith]="displayTeamName">
                      <mat-option *ngFor="let t of filteredHomeTeams" [value]="t">
                        {{ t.teamName }}
                      </mat-option>
                    </mat-autocomplete>
                  </mat-form-field>
                </div>
                <div class="form-group">
                  <label>Away Team <span class="required">*</span></label>
                  <mat-form-field class="full-width">
                    <input matInput placeholder="Search away team..."
                      [(ngModel)]="awayTeamFilter" name="awayTeamFilter"
                      [matAutocomplete]="awayAuto"
                      [disabled]="isLoadingRegisteredTeams">
                    <mat-autocomplete #awayAuto="matAutocomplete"
                      (optionSelected)="onTeamSelect('away', $event.option.value)"
                      [displayWith]="displayTeamName">
                      <mat-option *ngFor="let t of filteredAwayTeams" [value]="t">
                        {{ t.teamName }}
                      </mat-option>
                    </mat-autocomplete>
                  </mat-form-field>
                </div>
                <div class="form-group">
                  <label>Scheduled Date & Time <span class="required">*</span></label>
                  <input type="datetime-local" class="form-control" [(ngModel)]="matchForm.scheduledAt" name="scheduledAt">
                </div>
                <div class="form-group">
                  <label>Branch</label>
                  <select class="form-control" [(ngModel)]="matchForm.branchId" name="branchId">
                    <option [value]="null">Select branch</option>
                    <option *ngFor="let b of branches" [value]="b.id">{{ b.name }}</option>
                  </select>
                </div>
                <div class="form-group">
                  <label>Stage</label>
                  <select class="form-control" [(ngModel)]="matchForm.stage" name="stage">
                    <option [value]="null">None</option>
                    <option *ngFor="let s of matchStages" [value]="s">{{ s }}</option>
                  </select>
                </div>
                <div class="form-group" style="grid-column: 1 / -1;">
                  <label>Notes</label>
                  <textarea class="form-control" [(ngModel)]="matchForm.notes" name="notes"
                    rows="2" placeholder="Optional notes or instructions..."></textarea>
                </div>
              </div>
            </div>
          </form>

          <!-- Edit form -->
          <div *ngIf="isEditingMatch">
            <!-- Match header -->
            <div class="match-edit-header">
              <div class="match-edit-team home">{{ selectedMatch?.homeTeamName }}</div>
              <div class="match-edit-score">
                <input type="number" class="score-input" [(ngModel)]="matchEditForm.homeScore"
                  name="homeScore" min="0" placeholder="—">
                <span class="score-sep">–</span>
                <input type="number" class="score-input" [(ngModel)]="matchEditForm.awayScore"
                  name="awayScore" min="0" placeholder="—">
              </div>
              <div class="match-edit-team away">{{ selectedMatch?.awayTeamName }}</div>
            </div>

            <form class="registration-form" style="margin-top: 1.25rem;">
              <div class="form-grid-2">
                <div class="form-group">
                  <label>Date & Time</label>
                  <input type="datetime-local" class="form-control" [(ngModel)]="matchEditForm.scheduledAt" name="scheduledAt">
                </div>
                <div class="form-group">
                  <label>Location (Branch)</label>
                  <select class="form-control" [(ngModel)]="matchEditForm.branchId" name="branchId">
                    <option [value]="null">Select branch</option>
                    <option *ngFor="let b of branches" [value]="b.id">{{ b.name }}</option>
                  </select>
                </div>
                <div class="form-group">
                  <label>Stage</label>
                  <select class="form-control" [(ngModel)]="matchEditForm.stage" name="stage">
                    <option [value]="null">None</option>
                    <option *ngFor="let s of matchStages" [value]="s">{{ s }}</option>
                  </select>
                </div>
                <div class="form-group">
                  <label>Status</label>
                  <select class="form-control" [(ngModel)]="matchEditForm.status" name="status">
                    <option *ngFor="let s of matchStatuses" [value]="s">{{ s | titlecase }}</option>
                  </select>
                </div>
                <div class="form-group" style="grid-column: 1 / -1;">
                  <label>Notes</label>
                  <textarea class="form-control" [(ngModel)]="matchEditForm.notes" name="notes"
                    rows="2" placeholder="Optional notes or instructions..."></textarea>
                </div>
              </div>
            </form>
          </div>
        </div>

        <div class="modal-footer">
          <button class="btn btn-secondary" (click)="closeMatchModal()">Cancel</button>
          <button class="btn btn-primary" (click)="saveMatch()" [disabled]="isSavingMatch">
            {{ isSavingMatch ? 'Saving...' : (isEditingMatch ? 'Save Changes' : 'Create Match') }}
          </button>
        </div>
      </div>
    </div>

    <!-- Generate Group Modal -->
    <div *ngIf="showGroupModal" class="modal-overlay" (click)="closeGroupModal()">
      <div class="modal-content modal-content-wide" (click)="$event.stopPropagation()">
        <div class="modal-header">
          <h2>Generate Group Matches</h2>
          <button class="close-btn" (click)="closeGroupModal()">
            <svg viewBox="0 0 24 24"><path fill="currentColor" d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>
          </button>
        </div>

        <div class="modal-body">
          <div *ngIf="groupErrorMessage" class="alert alert-error">{{ groupErrorMessage }}</div>

          <div class="group-modal-layout">
            <!-- Left: config + team selection -->
            <div class="group-config">
              <div class="form-group">
                <label>Group Name <span class="required-star">*</span></label>
                <input type="text" class="form-control" [(ngModel)]="groupForm.groupName"
                  name="groupName" placeholder='e.g. "Group A"' maxlength="100">
              </div>

              <div class="form-group" style="margin-top: 1rem;">
                <label>Stage</label>
                <select class="form-control" [(ngModel)]="groupForm.stage" name="groupStage">
                  <option *ngFor="let s of matchStages" [value]="s">{{ s }}</option>
                </select>
              </div>

              <div class="form-group" style="margin-top: 1.25rem;">
                <label>Select Teams
                  <span class="field-hint">({{ groupForm.selectedTeamIds.size }} selected — {{ groupPreview.length }} matches)</span>
                </label>
                <div *ngIf="isLoadingRegisteredTeams" class="loading-inline">
                  <div class="loading-spinner loading-spinner-sm"></div>
                  <span>Loading teams...</span>
                </div>
                <div *ngIf="!isLoadingRegisteredTeams && registeredTeams.length === 0" class="alert alert-error">
                  No registered teams found. Register teams first.
                </div>
                <div class="team-checklist">
                  <label *ngFor="let t of registeredTeams" class="team-check-item"
                    [class.selected]="isGroupTeamSelected(t.id)"
                    (click)="toggleGroupTeam(t.id)">
                    <div class="team-check-box">
                      <svg *ngIf="isGroupTeamSelected(t.id)" viewBox="0 0 24 24"><path fill="currentColor" d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>
                    </div>
                    <span>{{ t.teamName }}</span>
                  </label>
                </div>
              </div>
            </div>

            <!-- Right: match preview -->
            <div class="group-preview">
              <h4 class="preview-title">Match Preview</h4>
              <div *ngIf="groupPreview.length === 0" class="preview-empty">
                Select teams to see the generated matches
              </div>
              <ol *ngIf="groupPreview.length > 0" class="preview-list">
                <li *ngFor="let pair of groupPreview" class="preview-item">
                  <span class="preview-home">{{ pair.home }}</span>
                  <span class="preview-vs">vs</span>
                  <span class="preview-away">{{ pair.away }}</span>
                </li>
              </ol>
              <div *ngIf="groupPreview.length > 0" class="preview-note">
                All matches will be created as <strong>Draft</strong> — no time or location assigned yet.
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button class="btn btn-secondary" (click)="closeGroupModal()">Cancel</button>
          <button class="btn btn-primary" (click)="generateGroup()"
            [disabled]="isGeneratingGroup || !groupForm.groupName.trim() || groupForm.selectedTeamIds.size < 2">
            {{ isGeneratingGroup ? 'Generating...' : 'Generate ' + groupPreview.length + ' Matches' }}
          </button>
        </div>
      </div>
    </div>

    <!-- Team Registration Modal -->
    <div *ngIf="showTeamModal" class="modal-overlay" (click)="closeTeamModal()">
      <div class="modal-content" (click)="$event.stopPropagation()">
        <div class="modal-header">
          <h2>Add Team Registration</h2>
          <button class="close-btn" (click)="closeTeamModal()">
            <svg viewBox="0 0 24 24">
              <path fill="currentColor" d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
            </svg>
          </button>
        </div>

        <div class="modal-body">
          <form class="registration-form">
            <!-- Team Info -->
            <div class="form-section">
              <h3>Team Information</h3>
              <div class="form-grid">
                <div class="form-group">
                  <label for="teamName">Team Name *</label>
                  <input type="text" id="teamName" [(ngModel)]="teamForm.teamName" name="teamName" required>
                </div>
                <div class="form-group">
                  <label for="jerseyColor">Jersey Color</label>
                  <input type="text" id="jerseyColor" [(ngModel)]="teamForm.jerseyColor" name="jerseyColor">
                </div>
                <div class="form-group">
                  <label for="nearestBranch">Nearest Branch</label>
                  <select id="nearestBranch" [(ngModel)]="teamForm.nearestBranch" name="nearestBranch">
                    <option value="">Select Branch</option>
                    <option *ngFor="let branch of branches" [value]="branch.name">{{branch.name}}</option>
                  </select>
                </div>
              </div>
            </div>

            <!-- Players -->
            <div class="form-section">
              <div class="section-header">
                <h3>Players ({{teamForm.players.length}})</h3>
                <button type="button" class="btn btn-secondary btn-sm" (click)="addPlayer()">
                  Add Player
                </button>
              </div>

              <div *ngIf="teamForm.players.length === 0" class="empty-players">
                No players added yet. Click "Add Player" to add players, or create the team first and add players later.
              </div>

              <div *ngFor="let player of teamForm.players; let i = index" class="player-form">
                <div class="player-header">
                  <h4>Player {{i + 1}}</h4>
                  <div class="player-actions">
                    <button type="button" class="btn-link" (click)="setCaptain(i)" [class.active]="player.isCaptain">
                      {{player.isCaptain ? '★ Captain' : 'Set as Captain'}}
                    </button>
                    <button type="button" class="btn-danger-sm" (click)="removePlayer(i)">
                      Remove
                    </button>
                  </div>
                </div>

                <div class="form-grid">
                  <div class="form-group">
                    <label>Full Name *</label>
                    <input type="text" [(ngModel)]="player.fullName" [name]="'playerName' + i" required>
                  </div>
                  <div class="form-group">
                    <label>Date of Birth *</label>
                    <input type="date" [(ngModel)]="player.dateOfBirth" [name]="'playerDob' + i" required>
                  </div>
                  <div class="form-group">
                    <label>Skill Level *</label>
                    <input type="text" [(ngModel)]="player.skillLevel" [name]="'playerSkill' + i" required>
                  </div>
                  <div class="form-group">
                    <label>Phone Number *</label>
                    <input type="tel" [(ngModel)]="player.phoneNumber" [name]="'playerPhone' + i" required>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>

        <div class="modal-footer">
          <button class="btn btn-secondary" (click)="closeTeamModal()" [disabled]="isSubmittingTeam">
            Cancel
          </button>
          <button class="btn btn-primary" (click)="submitTeamRegistration()" [disabled]="isSubmittingTeam">
            {{isSubmittingTeam ? 'Submitting...' : 'Submit Registration'}}
          </button>
        </div>
      </div>
    </div>

    <!-- Individual Registration Modal -->
    <div *ngIf="showIndividualModal" class="modal-overlay" (click)="closeIndividualModal()">
      <div class="modal-content" (click)="$event.stopPropagation()">
        <div class="modal-header">
          <h2>Add Individual Registration</h2>
          <button class="close-btn" (click)="closeIndividualModal()">
            <svg viewBox="0 0 24 24">
              <path fill="currentColor" d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
            </svg>
          </button>
        </div>

        <div class="modal-body">
          <form class="registration-form">
            <div class="form-grid">
              <div class="form-group">
                <label for="fullName">Full Name *</label>
                <input type="text" id="fullName" [(ngModel)]="individualForm.fullName" name="fullName" required>
              </div>
              <div class="form-group">
                <label for="gender">Gender</label>
                <select id="gender" [(ngModel)]="individualForm.gender" name="gender">
                  <option value="">Select Gender</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                </select>
              </div>
              <div class="form-group">
                <label for="dateOfBirth">Date of Birth</label>
                <input type="date" id="dateOfBirth" [(ngModel)]="individualForm.dateOfBirth" name="dateOfBirth">
              </div>
              <div class="form-group">
                <label for="phoneNumber">Phone Number</label>
                <input type="tel" id="phoneNumber" [(ngModel)]="individualForm.phoneNumber" name="phoneNumber">
              </div>
              <div class="form-group">
                <label for="skillLevel">Skill Level</label>
                <input type="text" id="skillLevel" [(ngModel)]="individualForm.skillLevel" name="skillLevel">
              </div>
              <div class="form-group">
                <label for="preferredPosition">Preferred Position</label>
                <input type="text" id="preferredPosition" [(ngModel)]="individualForm.preferredPosition" name="preferredPosition">
              </div>
              <div class="form-group">
                <label for="individualNearestBranch">Nearest Branch</label>
                <select id="individualNearestBranch" [(ngModel)]="individualForm.nearestBranch" name="individualNearestBranch">
                  <option value="">Select Branch</option>
                  <option *ngFor="let branch of branches" [value]="branch.name">{{branch.name}}</option>
                </select>
              </div>
            </div>
          </form>
        </div>

        <div class="modal-footer">
          <button class="btn btn-secondary" (click)="closeIndividualModal()" [disabled]="isSubmittingIndividual">
            Cancel
          </button>
          <button class="btn btn-primary" (click)="submitIndividualRegistration()" [disabled]="isSubmittingIndividual">
            {{isSubmittingIndividual ? 'Submitting...' : 'Submit Registration'}}
          </button>
        </div>
      </div>
    </div>

    <!-- Create Team Modal -->
    <app-create-team-modal
      [tournamentId]="tournamentId"
      [show]="showCreateTeamModal"
      (close)="closeCreateTeamModal()"
      (teamCreated)="onTeamCreated()"
    ></app-create-team-modal>

    <!-- Payment Recording Modal -->
    <div *ngIf="showPaymentModal" class="modal-overlay" (click)="closePaymentModal()">
      <div class="modal-content" (click)="$event.stopPropagation()">
        <div class="modal-header">
          <h2>Record Payment</h2>
          <button class="close-btn" (click)="closePaymentModal()">
            <svg viewBox="0 0 24 24">
              <path fill="currentColor" d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
            </svg>
          </button>
        </div>

        <div class="modal-body">
          <div *ngIf="paymentErrorMessage" class="alert alert-error">{{paymentErrorMessage}}</div>

          <form class="payment-form">
            <div class="payment-summary">
              <div class="summary-item">
                <label>Applied Fee</label>
                <p class="amount">{{getSelectedRegistrationFee() | currency:'EGP':'symbol':'1.2-2'}}</p>
              </div>
              <div class="summary-item">
                <label>Total Paid</label>
                <p class="amount">{{getSelectedRegistrationPaid() | currency:'EGP':'symbol':'1.2-2'}}</p>
              </div>
              <div class="summary-item highlight">
                <label>Remaining Balance</label>
                <p class="amount-large">{{getSelectedRegistrationBalance() | currency:'EGP':'symbol':'1.2-2'}}</p>
              </div>
            </div>

            <div class="form-grid">
              <div class="form-group">
                <label for="paymentAmount">Amount *</label>
                <input
                  type="number"
                  id="paymentAmount"
                  [(ngModel)]="paymentForm.amount"
                  name="paymentAmount"
                  [max]="getSelectedRegistrationBalance()"
                  min="0.01"
                  step="0.01"
                  required
                  placeholder="0.00"
                >
                <p class="form-hint">Maximum: {{getSelectedRegistrationBalance() | currency:'EGP':'symbol':'1.2-2'}}</p>
              </div>

              <div class="form-group">
                <label for="paymentMethod">Payment Method *</label>
                <select id="paymentMethod" [(ngModel)]="paymentForm.paymentMethod" name="paymentMethod" required>
                  <option *ngFor="let method of paymentMethods" [value]="method">{{method}}</option>
                </select>
              </div>

              <div class="form-group">
                <label for="paymentDate">Payment Date *</label>
                <input
                  type="date"
                  id="paymentDate"
                  [(ngModel)]="paymentForm.paymentDate"
                  name="paymentDate"
                  [max]="getTodayDate()"
                  required
                >
              </div>

              <div class="form-group">
                <label for="transactionReference">Transaction Reference</label>
                <input
                  type="text"
                  id="transactionReference"
                  [(ngModel)]="paymentForm.transactionReference"
                  name="transactionReference"
                  placeholder="Optional reference number"
                >
              </div>

              <div class="form-group full-width">
                <label for="paymentNotes">Notes</label>
                <textarea
                  id="paymentNotes"
                  [(ngModel)]="paymentForm.notes"
                  name="paymentNotes"
                  rows="3"
                  placeholder="Optional notes about this payment"
                ></textarea>
              </div>
            </div>
          </form>
        </div>

        <div class="modal-footer">
          <button class="btn btn-secondary" (click)="closePaymentModal()" [disabled]="isRecordingPayment">
            Cancel
          </button>
          <button class="btn btn-primary" (click)="recordPayment()" [disabled]="isRecordingPayment || !isPaymentFormValid()">
            {{isRecordingPayment ? 'Recording...' : 'Record Payment'}}
          </button>
        </div>
      </div>
    </div>

    <!-- Registration Detail Panel -->
    <div class="modal-overlay" *ngIf="showDetailPanel" (click)="closeDetailPanel()"></div>

    <div class="modal-container" *ngIf="showDetailPanel">
      <div class="modal-content" (click)="$event.stopPropagation()" style="width: 600px;">
        <!-- Header -->
        <div class="modal-header">
          <h2 class="modal-title">
            <span *ngIf="selectedRegistrationTypeForDetail === 'team'">Team Registration Details</span>
            <span *ngIf="selectedRegistrationTypeForDetail === 'individual'">Individual Registration Details</span>
          </h2>
          <div style="display: flex; gap: 0.5rem; align-items: center;">
            <button *ngIf="!isEditingRegistration" class="btn btn-sm btn-primary" (click)="toggleEditMode()">
              Edit
            </button>
            <button class="close-btn" (click)="closeDetailPanel()">✕</button>
          </div>
        </div>

        <!-- Body -->
        <div class="modal-body">
          <!-- Team Registration Details -->
          <div *ngIf="selectedRegistrationTypeForDetail === 'team' && selectedRegistration">
            <ng-container *ngIf="!isEditingRegistration">
              <!-- Team Info View Mode -->
              <div class="info-section">
                <h3>Team Information</h3>
                <div class="info-row">
                  <div class="info-col">
                    <label>Team Name</label>
                    <p>{{selectedRegistration.teamName}}</p>
                  </div>
                  <div class="info-col">
                    <label>Jersey Color</label>
                    <p><span class="badge" [style.background-color]="selectedRegistration.jerseyColor">
                      {{selectedRegistration.jerseyColor}}
                    </span></p>
                  </div>
                </div>
                <div class="info-row">
                  <div class="info-col">
                    <label>Nearest Branch</label>
                    <p>{{selectedRegistration.nearestBranch || 'Not specified'}}</p>
                  </div>
                  <div class="info-col">
                    <label>Academy Member</label>
                    <p>{{selectedRegistration.isAcademyMember ? 'Yes' : 'No'}}</p>
                  </div>
                </div>
                <div class="info-row">
                  <div class="info-col">
                    <label>Registered By</label>
                    <p>{{selectedRegistration.registeredBy}}</p>
                  </div>
                  <div class="info-col">
                    <label>Phone Number</label>
                    <p>{{selectedRegistration.phoneNumber}}</p>
                  </div>
                </div>
                <div class="info-row">
                  <div class="info-col">
                    <label>Registration Date</label>
                    <p>{{selectedRegistration.createdAt | date: 'medium'}}</p>
                  </div>
                  <div class="info-col">
                    <label>Status</label>
                    <p><span class="badge" [class]="'status-' + selectedRegistration.status?.toLowerCase()">
                      {{selectedRegistration.status}}
                    </span></p>
                  </div>
                </div>
              </div>

              <!-- Payment Info -->
              <div class="info-section">
                <h3>Payment Information</h3>
                <div class="info-row">
                  <div class="info-col">
                    <label>Applied Fee</label>
                    <p>{{selectedRegistration.appliedFee}} EGP</p>
                  </div>
                  <div class="info-col">
                    <label>Total Paid</label>
                    <p>{{selectedRegistration.totalPaid}} EGP</p>
                  </div>
                </div>
                <div class="info-row">
                  <div class="info-col">
                    <label>Remaining Balance</label>
                    <p>{{selectedRegistration.remainingBalance}} EGP</p>
                  </div>
                  <div class="info-col">
                    <label>Payment Status</label>
                    <p><span class="badge" [class]="getPaymentStatusBadgeClass(selectedRegistration.paymentStatus)">
                      {{getPaymentStatusLabel(selectedRegistration.paymentStatus)}}
                    </span></p>
                  </div>
                </div>
                <div *ngIf="selectedRegistration.remainingBalance > 0" style="margin-top: 1rem;">
                  <button class="btn btn-primary btn-sm"
                          (click)="openPaymentModal(selectedRegistration.id, 'team', selectedRegistration.remainingBalance)">
                    Record Payment
                  </button>
                </div>
              </div>

              <!-- Players -->
              <div class="info-section">
                <div class="section-header-row">
                  <h3>Players ({{selectedRegistration.players?.length || 0}})</h3>
                  <button class="btn btn-secondary btn-sm" (click)="openAddPlayerForm()" *ngIf="!showAddPlayerForm">
                    + Add Player
                  </button>
                </div>

                <!-- Add Player Form -->
                <div *ngIf="showAddPlayerForm" class="add-player-form">
                  <div class="form-grid-2col">
                    <div class="form-group">
                      <label>Full Name *</label>
                      <input type="text" class="form-control" [(ngModel)]="addPlayerForm.fullName" placeholder="Player name">
                    </div>
                    <div class="form-group">
                      <label>Phone Number</label>
                      <input type="tel" class="form-control" [(ngModel)]="addPlayerForm.phoneNumber" placeholder="Phone number">
                    </div>
                    <div class="form-group">
                      <label>Gender</label>
                      <select class="form-control" [(ngModel)]="addPlayerForm.gender">
                        <option [ngValue]="null">Select</option>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                      </select>
                    </div>
                    <div class="form-group">
                      <label>Date of Birth</label>
                      <input type="date" class="form-control" [(ngModel)]="addPlayerForm.dateOfBirth">
                    </div>
                    <div class="form-group">
                      <label>Skill Level</label>
                      <select class="form-control" [(ngModel)]="addPlayerForm.skillLevel">
                        <option [ngValue]="null">Select</option>
                        <option value="Beginner">Beginner</option>
                        <option value="Intermediate">Intermediate</option>
                        <option value="Advanced">Advanced</option>
                      </select>
                    </div>
                    <div class="form-group">
                      <label>Position</label>
                      <input type="text" class="form-control" [(ngModel)]="addPlayerForm.preferredPosition" placeholder="Preferred position">
                    </div>
                  </div>
                  <div class="add-player-actions">
                    <button class="btn btn-secondary btn-sm" (click)="closeAddPlayerForm()" [disabled]="isAddingPlayer">Cancel</button>
                    <button class="btn btn-primary btn-sm" (click)="submitAddPlayer()" [disabled]="isAddingPlayer || !addPlayerForm.fullName.trim()">
                      {{isAddingPlayer ? 'Adding...' : 'Add Player'}}
                    </button>
                  </div>
                </div>

                <div class="players-list">
                  <div *ngIf="!selectedRegistration.players?.length" class="empty-players">
                    No players added yet. Click "Add Player" to add players to this team.
                  </div>
                  <div *ngFor="let player of selectedRegistration.players" class="player-item">
                    <div class="player-avatar">
                      {{getInitials(player.fullName)}}
                    </div>
                    <div class="player-info">
                      <div class="player-name">
                        {{player.fullName}}
                        <span *ngIf="player.isCaptain" class="badge badge-blue">Captain</span>
                      </div>
                      <div class="player-meta">
                        <span *ngIf="player.dateOfBirth">Age: {{calculateAge(player.dateOfBirth)}}</span>
                        <span *ngIf="player.skillLevel"> • Skill: {{player.skillLevel}}</span>
                        <span *ngIf="player.phoneNumber"> • {{player.phoneNumber}}</span>
                      </div>
                    </div>
                    <button class="btn-remove-player" title="Remove player" (click)="removeTeamPlayer(player.id)">
                      <svg viewBox="0 0 24 24" width="16" height="16">
                        <path fill="currentColor" d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </ng-container>

            <!-- Team Edit Mode -->
            <ng-container *ngIf="isEditingRegistration">
              <div class="form-section">
                <div class="form-group">
                  <label>Team Name *</label>
                  <input type="text" class="form-control" [(ngModel)]="registrationEditForm.teamName">
                </div>
                <div class="form-row">
                  <div class="form-group">
                    <label>Jersey Color</label>
                    <input type="color" class="form-control" [(ngModel)]="registrationEditForm.jerseyColor">
                  </div>
                  <div class="form-group">
                    <label>Nearest Branch</label>
                    <input type="text" class="form-control" [(ngModel)]="registrationEditForm.nearestBranch">
                  </div>
                </div>
                <div class="form-checkbox">
                  <input type="checkbox" id="teamAcademyEdit" [(ngModel)]="registrationEditForm.isAcademyMember">
                  <label for="teamAcademyEdit" class="checkbox-label">Academy Member</label>
                </div>
              </div>
            </ng-container>
          </div>

          <!-- Individual Registration Details -->
          <div *ngIf="selectedRegistrationTypeForDetail === 'individual' && selectedRegistration">
            <ng-container *ngIf="!isEditingRegistration">
              <!-- Personal Info View Mode -->
              <div class="info-section">
                <h3>Personal Information</h3>
                <div class="info-row">
                  <div class="info-col">
                    <label>Full Name</label>
                    <p>{{selectedRegistration.fullName}}</p>
                  </div>
                  <div class="info-col">
                    <label>Gender</label>
                    <p>{{selectedRegistration.gender || 'Not specified'}}</p>
                  </div>
                </div>
                <div class="info-row">
                  <div class="info-col">
                    <label>Date of Birth</label>
                    <p>{{selectedRegistration.dateOfBirth ? (selectedRegistration.dateOfBirth | date: 'mediumDate') : 'Not specified'}}</p>
                  </div>
                  <div class="info-col">
                    <label>Phone Number</label>
                    <p>{{selectedRegistration.phoneNumber || 'Not specified'}}</p>
                  </div>
                </div>
                <div class="info-row">
                  <div class="info-col">
                    <label>Preferred Position</label>
                    <p>{{selectedRegistration.preferredPosition || 'Not specified'}}</p>
                  </div>
                  <div class="info-col">
                    <label>Skill Level</label>
                    <p>{{selectedRegistration.skillLevel || 'Not specified'}}</p>
                  </div>
                </div>
                <div class="info-row">
                  <div class="info-col">
                    <label>Nearest Branch</label>
                    <p>{{selectedRegistration.nearestBranch || 'Not specified'}}</p>
                  </div>
                  <div class="info-col">
                    <label>Academy Member</label>
                    <p>{{selectedRegistration.isAcademyMember ? 'Yes' : 'No'}}</p>
                  </div>
                </div>
              </div>

              <div class="info-section">
                <h3>Registration Details</h3>
                <div class="info-row">
                  <div class="info-col">
                    <label>Registered By</label>
                    <p>{{selectedRegistration.registeredBy}}</p>
                  </div>
                  <div class="info-col">
                    <label>Registered By Phone</label>
                    <p>{{selectedRegistration.registeredByPhone}}</p>
                  </div>
                </div>
                <div class="info-row">
                  <div class="info-col">
                    <label>Registration Date</label>
                    <p>{{selectedRegistration.createdAt | date: 'medium'}}</p>
                  </div>
                  <div class="info-col">
                    <label>Status</label>
                    <p><span class="badge" [class]="'status-' + selectedRegistration.status?.toLowerCase()">
                      {{selectedRegistration.status}}
                    </span></p>
                  </div>
                </div>
                <div class="info-row" *ngIf="selectedRegistration.assignedTeamName">
                  <div class="info-col">
                    <label>Assigned Team</label>
                    <p>{{selectedRegistration.assignedTeamName}}</p>
                  </div>
                </div>
              </div>

              <!-- Payment Info -->
              <div class="info-section">
                <h3>Payment Information</h3>
                <div class="info-row">
                  <div class="info-col">
                    <label>Applied Fee</label>
                    <p>{{selectedRegistration.appliedFee}} EGP</p>
                  </div>
                  <div class="info-col">
                    <label>Total Paid</label>
                    <p>{{selectedRegistration.totalPaid}} EGP</p>
                  </div>
                </div>
                <div class="info-row">
                  <div class="info-col">
                    <label>Remaining Balance</label>
                    <p>{{selectedRegistration.remainingBalance}} EGP</p>
                  </div>
                  <div class="info-col">
                    <label>Payment Status</label>
                    <p><span class="badge" [class]="getPaymentStatusBadgeClass(selectedRegistration.paymentStatus)">
                      {{getPaymentStatusLabel(selectedRegistration.paymentStatus)}}
                    </span></p>
                  </div>
                </div>
                <div *ngIf="selectedRegistration.remainingBalance > 0" style="margin-top: 1rem;">
                  <button class="btn btn-primary btn-sm"
                          (click)="openPaymentModal(selectedRegistration.id, 'individual', selectedRegistration.remainingBalance)">
                    Record Payment
                  </button>
                </div>
              </div>
            </ng-container>

            <!-- Individual Edit Mode -->
            <ng-container *ngIf="isEditingRegistration">
              <div class="form-section">
                <div class="form-group">
                  <label>Full Name *</label>
                  <input type="text" class="form-control" [(ngModel)]="registrationEditForm.fullName">
                </div>
                <div class="form-row">
                  <div class="form-group">
                    <label>Gender</label>
                    <select class="form-control" [(ngModel)]="registrationEditForm.gender">
                      <option value="">Not specified</option>
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                    </select>
                  </div>
                  <div class="form-group">
                    <label>Date of Birth</label>
                    <input type="date" class="form-control" [(ngModel)]="registrationEditForm.dateOfBirth">
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group">
                    <label>Preferred Position</label>
                    <input type="text" class="form-control" [(ngModel)]="registrationEditForm.preferredPosition">
                  </div>
                  <div class="form-group">
                    <label>Skill Level</label>
                    <select class="form-control" [(ngModel)]="registrationEditForm.skillLevel">
                      <option value="">Not specified</option>
                      <option value="Beginner">Beginner</option>
                      <option value="Intermediate">Intermediate</option>
                      <option value="Advanced">Advanced</option>
                    </select>
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group">
                    <label>Phone Number</label>
                    <input type="tel" class="form-control" [(ngModel)]="registrationEditForm.phoneNumber">
                  </div>
                  <div class="form-group">
                    <label>Nearest Branch</label>
                    <input type="text" class="form-control" [(ngModel)]="registrationEditForm.nearestBranch">
                  </div>
                </div>
                <div class="form-checkbox">
                  <input type="checkbox" id="individualAcademyEdit" [(ngModel)]="registrationEditForm.isAcademyMember">
                  <label for="individualAcademyEdit" class="checkbox-label">Academy Member</label>
                </div>
              </div>
            </ng-container>
          </div>

          <!-- Payment History (future feature) -->
          <div class="info-section" *ngIf="selectedRegistration && selectedRegistration.totalPaid > 0">
            <h3>Payment History</h3>
            <p class="text-muted">Payment history feature coming soon</p>
          </div>
        </div>

        <!-- Footer -->
        <div class="modal-footer" *ngIf="isEditingRegistration">
          <button class="btn btn-secondary" (click)="toggleEditMode()" [disabled]="isSavingRegistration">Cancel</button>
          <button class="btn btn-primary" (click)="saveRegistrationChanges()" [disabled]="isSavingRegistration">
            {{isSavingRegistration ? 'Saving...' : 'Save Changes'}}
          </button>
        </div>
      </div>
    </div>
    </div> <!-- tournament-detail -->
  </main>
</div>
